import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "¿Cuál es la hora de check-in y check-out?",
    a: "El check-in es a partir de las 15:00 hrs y el check-out hasta las 12:00 hrs. Sujeto a disponibilidad, podemos ofrecer flexibilidad en los horarios — consúltanos al hacer tu reserva.",
  },
  {
    q: "¿Cuál es la política de cancelación?",
    a: "Las cancelaciones realizadas con más de 14 días de anticipación reciben reembolso completo. Entre 7 y 14 días, 50% de reembolso. Menos de 7 días no son reembolsables, salvo causas de fuerza mayor.",
  },
  {
    q: "¿Aceptan mascotas?",
    a: "Sí, Casa El Gavillero es pet-friendly. Contamos con áreas designadas y amenities especiales para tu mascota. Notifícanos al reservar para preparar todo.",
  },
  {
    q: "¿Se puede organizar un evento o boda?",
    a: "Por supuesto. Contamos con espacios diseñados para bodas, eventos familiares y retiros corporativos. Contáctanos para diseñar una experiencia a tu medida.",
  },
  {
    q: "¿Qué incluye la estancia?",
    a: "La estancia incluye acceso a todas las amenidades (piscina, spa, gimnasio), servicio de limpieza diario, desayuno gourmet y servicio de conserjería durante tu visita.",
  },
  {
    q: "¿Ofrecen servicio de transporte?",
    a: "Sí, contamos con servicio de transporte privado desde/hacia el aeropuerto y puntos cercanos. Se puede coordinar al momento de la reserva.",
  },
];

export default function FAQ() {
  const { ref, isVisible } = useScrollReveal();
  const [open, setOpen] = useState(null);

  return (
    <section className="py-28 md:py-40 px-6 lg:px-10 bg-secondary/30">
      <div className="max-w-3xl mx-auto" ref={ref}>
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 1 }}
            className="text-accent text-sm tracking-[0.3em] uppercase font-light mb-6 block"
          >
            Preguntas Frecuentes
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, delay: 0.1 }}
            className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-light text-foreground text-balance"
          >
            Resolvemos tus dudas
          </motion.h2>
        </div>

        <div className="space-y-2">
          {FAQS.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={isVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: i * 0.05 }}
              className="border-b border-border"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 py-6 text-left group"
              >
                <span className="font-serif-display text-lg md:text-xl text-foreground group-hover:text-accent transition-colors">
                  {faq.q}
                </span>
                <span className="flex-shrink-0 text-accent">
                  {open === i ? <Minus size={20} /> : <Plus size={20} />}
                </span>
              </button>
              <AnimatePresence>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <p className="pb-6 text-foreground/60 font-light leading-relaxed">
                      {faq.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}